<template>
    <div class="fc" :class="{ on: isActive }" v-ripple @click="$emit('click')">
        <template v-if="createMode">
            <div class="fiw">
                <v-icon size="22" color="accent">mdi-folder-plus-outline</v-icon>
            </div>
            <div class="fn">{{ $t('common.create') }} {{ $t('common.folder') }}</div>
        </template>
        <template v-else-if="folder">
            <button v-if="canEdit" type="button" class="fc-edit-btn" @click.stop="$emit('click:edit')">
                <v-icon size="11">$edit</v-icon>
            </button>
            <div class="fiw">
                <v-img v-if="folder.img" :src="folder.img" height="46" width="46" class="fiw-img" />
                <v-icon v-else size="22" :color="isActive ? 'secondary' : 'accent'">
                    {{ folder.icon || (isActive ? 'mdi-folder-open-outline' : 'mdi-folder-outline') }}
                </v-icon>
            </div>
            <div class="fn text-truncate" :class="{ 'fn--on': isActive }">{{ folderLabel(folder) }}</div>
        </template>
    </div>
</template>

<script>
export default {
    name: "FolderCard",
    props: {
        createMode: {
            type: Boolean,
            default: false,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
        folder: {
            type: Object,
            default: null,
        },
        noEdit: {
            type: Boolean,
            default: false,
        },
        size: {
            type: [String, Number],
            default: '100',
        },
        minHeight: {
            type: [String, Number],
            default: undefined,
        },
    },
    computed: {
        canEdit(vm = this) {
            if (vm.noEdit) return false
            return vm.folder?.coachId
        }
    },
}
</script>

<style scoped>
.fc {
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 12px;
    padding: 18px 14px;
    text-align: center;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: all .15s;
    height: 100%;
    position: relative;
}

.fc:hover {
    border-color: var(--v-outline2-base);
    background: var(--v-surface2-base);
}

.fc.on {
    border-color: var(--v-accent-base);
    background: rgba(51, 153, 153, .08);
}

.fiw {
    width: 46px;
    height: 46px;
    border-radius: 10px;
    background: var(--v-surface2-base);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    overflow: hidden;
}

.fiw-img {
    border-radius: 10px;
}

.fn {
    font-size: 13px;
    font-weight: 500;
    color: var(--v-txtPrimary-base);
    margin-top: 10px;
    max-width: 100%;
}

.fn--on {
    color: var(--v-secondary-base);
}

.fc-edit-btn {
    position: absolute;
    top: 7px;
    right: 7px;
    width: 22px;
    height: 22px;
    border-radius: 5px;
    border: 1px solid var(--v-outline-base);
    background: var(--v-surface-base);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: var(--v-txtMuted-base);
    opacity: 0;
    transition: opacity .15s;
    z-index: 2;
}

.fc:hover .fc-edit-btn {
    opacity: 1;
}

.fc-edit-btn:hover {
    color: var(--v-txtPrimary-base);
    border-color: var(--v-outline2-base);
}

.fc-edit-btn >>> .v-icon {
    color: inherit !important;
}
</style>
